/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-11-25 12:26:02
 * @LastEditTime: 2026-06-19 23:59:00
 * @Description:
 */

import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FAQSection from './components/FAQSection';
import ContactCTASection from './components/ContactCTASection';
import { useIsHongKongIp } from '../../hooks/useIsHongKongIp';

export default function FAQPage() {
  const { t } = useTranslation();
  const { canShowRestrictedContent } = useIsHongKongIp();

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Suspense fallback={<div>{t('common.loading')}</div>}>
          <HeroSection />

          {/* 只有香港 IP 不顯示；中國及其他地區照常顯示 */}
          {canShowRestrictedContent && <FAQSection />}

          <ContactCTASection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
